<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>
<script>
// 引入基本模板
import echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
export default {
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "280px",
    },
  },
  data() {
    return {
      chart: null,
      text: [],
      isMB: this.$store.state.isMB,
      option: {
        backgroundColor: "#ffffff",
        xAxis: {
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: '#999', //坐标轴字体颜色
              fontSize: 14
            },
          },
          type: "category",
          splitLine: {
            lineStyle: {
              show: true,
              type: "dashed",
            }
          },
          data: [],
        },
        grid: {
          top: "5%",
          bottom: "11%",
          left: "10%",
          right: "6%"
        },
        yAxis: {
          axisLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: '#999', //坐标轴字体颜色
              fontSize: 14
            },
          },
          splitArea: {
            show: false
          },
          axisTick: {
            show: false
          },
          type: "value",
          splitLine: {
            lineStyle: {
              show: true,
              type: "dashed"
            }
          },
          minInterval: "1"
        },
        series: [
          {
            data: [],
            color: "#6071cb",
            type: "line",
            smooth: true,
            symbolSize: 0,
            label: {
							show: true,
						}
          },
        ],
      }
    };
  },
  mounted() {
    this.initChart()
    let self = this
    setInterval(function(){
      self.initChart();
    }, 60000);
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart(data=[],xname="",yname="") {
      this.text = []
      for(var i=0;i<data.length;i++) {
        this.option.series[0].data[i] = data[i].Value
        this.text.push(data[i].Text)
      }
      this.option.xAxis.data = this.text
      // if(this.isMB) {
      //   this.option.grid.left = "12%";
      //   // this.option.grid.bottom = "7%";
      //   this.option.grid.bottom = "7%";
      //   this.option.grid.right = "5%";
      // }
      this.option.xAxis.name = xname;
      this.option.yAxis.name = yname;
      this.chart = echarts.init(this.$el, "macarons");
      this.chart.setOption(this.option);
    },
  },
};
</script>